export default __webpack_public_path__ + "static/media/home-banner.0b4bbf4a.jpg";